//submenu validator
let submenuOpened = false;
const HEADER = document.getElementById('header');
//resize sizes
const w = window,
	d = document,
	e = d.documentElement,
	g = d.getElementsByTagName('body')[0];
let WINDOW_WIDTH = w.innerWidth || e.clientWidth || g.clientWidth,
	WINDOW_HEIGHT = w.innerHeight || e.clientHeight || g.clientHeight;

const DOCUMENT_HEIGHT = document.body.scrollHeight;

const userAgent = navigator.userAgent.toLowerCase();
const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);

resizeWindow();

if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {
	
	// MOBILE SUB-MENU TO SELECT
	document.querySelectorAll('.mobile .sub-menu__container .sub-menu').forEach((submenu) => {
		const activeItem = submenu.querySelector('a.active') ? submenu.querySelector('a.active') : submenu.querySelector('a');
		const items = Array.from(submenu.querySelectorAll('a'))
			.map((link) => `<option value="${link.getAttribute('href')}">${link.innerText}</option>`)
			.join('');

		submenu.querySelector('ul').classList.add('hidden');

		submenu.insertAdjacentHTML('beforeend', `<select>${items}</select>`);
		submenu.querySelector('select').value = activeItem.getAttribute('href');
		submenu.querySelector('select').addEventListener('change', (e) => {
			window.location = e.target.value;
		});
	});

	//MOBILE RESERVATION TOOGLE
	let mobileReservation = document.getElementById('mobileReservation');
	if(mobileReservation) {
		const originalText = mobileReservation.textContent;
		mobileReservation.addEventListener('click', e => {
			if(e.target === mobileReservation) {
				let containerReservation = document.getElementById('mbReservContainer');
				containerReservation.classList.toggle('hidden');
				if(containerReservation.classList.contains('hidden')) {
					e.target.textContent = originalText;
				} else {
					e.target.textContent = "CLOSE";
				}
			}
		});
	}

	const toggleButton = document.getElementById('stackCtaToggle');
	const toggleContainer = document.querySelector('.toggleCTAReserv');
	
	if(toggleButton && toggleContainer) {
		const originalText = toggleButton.querySelector('a').textContent;
		let widthButton = toggleButton.offsetWidth;
		toggleButton.addEventListener('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			toggleContainer.classList.toggle('hidden');
			if(toggleContainer.classList.contains('hidden')){
				toggleContainer.style.width = 0;
			}
			else{
				toggleContainer.style.width = widthButton+'px';	
			}
			toggleContainer.classList.toggle('openToggle');

		});
	}

	// RESERV CTA TOGGLE MOBILE
	

	// LANGUAGE SELECTOR
	document.querySelectorAll('.header-languages__active').forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();

			if (document.querySelector('.header-languages__options')) {
				document.querySelector('.header-languages__options').classList.toggle('open');
			}
		});
	});

	document.addEventListener('DOMContentLoaded', function (event) {
		window.onload = onLoad();
		addTrackingClass();
		//ADA
		// document.addEventListener('keyup', function(event) {
		// 	if (event.key === 'Tab') {
		// 		 const skipLink = document.querySelector('.skip-to-content');
		// 		if (skipLink) {
		// 			const activeElement = document.activeElement;
		// 			const isBodyOrHtml = activeElement === document.body || activeElement === document.documentElement;
		// 			if (isBodyOrHtml && !skipLink.hasBeenFocused) {
		// 				skipLink.focus();
		// 				skipLink.hasBeenFocused = true;
		// 			}
		// 		}
		// 	}
		// });

	});


	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach((e) => (e.innerHTML.trim() === '' || e.innerHTML.trim() === ' ') && e.parentNode.removeChild(e));

	if ((document.getElementById('home') || document.getElementsByClassName('internal-scroll').length > 0) && document.getElementsByClassName('no-hero-image').length == 0) {
		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		});
	} else {
		if (document.getElementsByClassName('no-hero-image').length > 0) {
			HEADER.classList.add('sticky');
		}
		HEADER.classList.add('scroll');
		changeSrc(document.getElementById('headerLogo').getElementsByTagName('img')[0]);
	}
	window.addEventListener('resize', function () {
		resizeWindow();
		console.log(isTablet)
	});

	//PRIMARY SUB MENU
	if(document.getElementById('primary-nav') || document.getElementById('mobile-primary-nav') || document.getElementById('navigation-container')){
		let allMainLinks = null;
		if(document.getElementById('primary-nav')){
			allMainLinks = document.getElementById('primary-nav').querySelectorAll('a');
		}
		else if(document.getElementById('mobile-primary-nav')){
			allMainLinks = document.getElementById('mobile-primary-nav').querySelectorAll('a');
		}
		else if(document.getElementById('navigation-container')){
			allMainLinks = document.getElementById('navigation-container').querySelectorAll('a');
		}
		allMainLinks.forEach((link) => {

			if(WINDOW_WIDTH > 1090){

				if(link.nextElementSibling && link.nextElementSibling.classList.contains('submenu')){
					link.classList.add('hover-active');
					link.nextElementSibling.querySelectorAll('a').forEach(l => l.classList.add('hover-active'))
					let menuContainer = document.getElementById('menuContainer');
					if(menuContainer && menuContainer.classList.contains('menu-half')){
						link.addEventListener('click', function (e) {
							e.preventDefault();
							if(!link.parentElement.classList.contains('open')){
								document.querySelectorAll('.privary-navigation__item').forEach(item => {
									if(item.classList.contains("open")){
										item.classList.remove("open");
									}
								});
							}
							if(link.nextElementSibling != null || link.nextElementSibling !=undefined){
								if (this.nextElementSibling.classList.contains('submenu')) { 
									this.parentElement.classList.toggle('open');
								}
							}
						});

					}
					else{
						link.parentElement.addEventListener('mouseleave', function (e) {
							if (link.nextElementSibling.classList.contains('submenu')) {
								if (link.parentElement.classList.contains('open')) {
									link.parentElement.classList.remove('open');
									submenuOpened = false;
								} 
							}
						});
						link.addEventListener('mouseenter', function (e) {
							if(link.nextElementSibling != null || link.nextElementSibling !=undefined){
								if (this.nextElementSibling.classList.contains('submenu')) {
									submenuOpened = false;
									this.parentElement.classList.add('open');
									setTimeout(() => {
										submenuOpened = true;
									}, 400);
								}
							}
						});
					}
						
					if(!link.classList.contains('hover-active')){
						link.addEventListener('mouseleave', function (e) {
							document.querySelectorAll('.open').forEach(sub => sub.classList.remove('open'))
							submenuOpened = false;
						});
					}
				}

			} else {
				link.addEventListener('click', function (e) {
					if(this.nextElementSibling != null || this.nextElementSibling !=undefined){
						if (this.nextElementSibling.classList.contains('submenu') ||this.nextElementSibling.classList.contains('sub-sub-menu')) {
							e.preventDefault();
							submenuOpened = false;
							this.parentElement.classList.add('open');
							setTimeout(() => {
								submenuOpened = true;
							}, 600);
						}
					}
				});
			}
		});
		if(WINDOW_WIDTH < 1090){
			if(document.getElementsByClassName('submenu').length > 0){
				submenuOpened = false;
				document.addEventListener('click', function(e){
					if(document.querySelectorAll('.sub-sub-menu')){
						document.querySelectorAll('.sub-sub-menu').forEach( subnav => {
							//console.log(subnav.parentElement.contains(e.target));
							if(subnav.parentElement.contains(e.target) === false){
								subnav.parentElement.classList.remove('open')
							}
						})
					}
					else{
						document.querySelectorAll('.submenu').forEach( subnav => {
							//console.log(subnav.parentElement.contains(e.target));
							if(subnav.parentElement.contains(e.target) === false){
								subnav.parentElement.classList.remove('open')
							}
						})
					}
				})
			}
		}
	}

	if (document.getElementById('menuClose')) {
		document.getElementById('menuClose').addEventListener('click', function (e) {
			e.preventDefault();
			document.getElementById('menuContainer').classList.remove('open');
		});
		document.addEventListener('keydown', function(event) {
			if (event.key === 'Escape' || event.key === 'Esc') { 
				document.getElementById('menuContainer').classList.remove('open');
			}	
		});
	}
	if (document.getElementById('burgerMenu')) {
		document.getElementById('burgerMenu').addEventListener('click', function (e) {
			e.preventDefault();
			document.getElementById('menuContainer').classList.add('open');
		});				
	}

	//MENU HALF CLOSE OUT IF MENU
	const menuExists = document.querySelector('.menu-half');
	if (menuExists &&  menuExists != null) {
		document.addEventListener('click', function(event) {
			const menuContainer = document.getElementById('menuContainer');
			const burgerMenu = document.getElementById('burgerMenu');
			if(menuContainer){
				const isMenuOpen = menuContainer.classList.contains('open') && menuContainer.classList.contains('menu-half');
				if (isMenuOpen && !menuContainer.contains(event.target) && !burgerMenu.contains(event.target)) {
					menuContainer.classList.remove('open');
				}
			}
		});
	}

	//EMAIL SIGNUP FIELDS ANIMATIONS
	if(document.getElementsByClassName('fields-wrap').length > 0){
		document.querySelectorAll('.fields-wrap').forEach(block => {
			block.querySelectorAll('input').forEach(input => {
				if(input.getAttribute('type') !== 'checkbox'){
					input.addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					});
				}
			})
		})
	}

	//CMS FORMS ANIMATIONS
	if (document.getElementsByClassName('form-module__field').length > 0) {
		const MODULE_FIELDS = document.querySelectorAll('.form-module__field');
		MODULE_FIELDS.forEach((field) => {
			if (field.getElementsByTagName('input').length > 0) {
				if (field.getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					field.getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					});
				}
			}
			if (field.getElementsByTagName('select').length > 0) {
				field.getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
			if (field.getElementsByTagName('textarea').length > 0) {
				field.getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
		});
	}

	//COUNT ELEMENTS STYLE
	 if(document.querySelector('.header-traditional #privary-navigation')){
		if(document.querySelectorAll('.header-traditional #privary-navigation li').length > 6){
			document.getElementById("privary-navigation").classList.add('justify-items');
		}
	}

	//SUBITEMS MENU AVTICE
	let navigationMain = document.querySelector('#privary-navigation');
	if(navigationMain){
		let listSub = navigationMain.querySelectorAll('li:has(.submenu)')
		listSub.forEach(element => {
			element.querySelectorAll('ul li a').forEach(a => {
				if(a.classList.contains('active')){
					element.children[0].classList.add('active');
					return;
				}
				else{
					a.classList.remove('active');
				}
			});
		});;
	}

	//slick
	$('.sym-slides').slick({
		accessibility: false,
	});

	$('.cb-slides').slick({
		accessibility: false,
		slidesToShow: 3,
		responsive: [
			{
				breakpoint: 1000,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	});

	$('[data-slick_prev]').click(function () {
		const $curSlider = $(this).data('slick-target') ? $($(this).data('slick-target')) : $(this).closest('.slick-initialized');
		$curSlider.slick('slickPrev');
	});

	$('[data-slick_next]').click(function () {
		const $curSlider = $(this).data('slick-target') ? $($(this).data('slick-target')) : $(this).closest('.slick-initialized');
		$curSlider.slick('slickNext');
	});

	//DOTS SLIDER//////////////////////////////////////////////////////////// jQuery :(
	//dots slides
	$('.dots-slider').on('afterChange', function (event, slick, currentSlide) {
		let currentTarget = $(this).attr('data-target');

		if ($('#' + currentTarget).length > 0) {
			$('#' + currentTarget + ' .dot').each(function (e) {
				$(this).removeClass('active');
			});
			$('#' + currentTarget + ' .dot[data-target=' + currentSlide + ']').addClass('active');
		}
	});
	$('.slider-dots, .slider-numbers').each(function () {
		let currentTarget = $(this).attr('data-target');
		let self = $(this);
		self.find('.dot').click(function () {
			let target = $(this).attr('data-target');
			self.find('.dot').each(function () {
				$(this).removeClass('active');
			});
			$(this).addClass('active');
			$('#' + currentTarget).slick('slickGoTo', target);
		});
	});
	//numbers
	$('.numbers-slider').on('afterChange', function (event, slick, currentSlide) {
		let currentTarget = $(this).attr('data-number');

		if ($('#' + currentTarget).length > 0) {
			$('#' + currentTarget + ' .dot').each(function (e) {
				$(this).removeClass('active');
			});
			$('#' + currentTarget + ' .dot[data-target=' + currentSlide + ']').addClass('active');
		}
	});
    
	//vanilla JS fancybox
	if (document.getElementsByClassName('lightbox').length > 0) {
		document.querySelectorAll('.lightbox').forEach( modal => document.querySelector('main').appendChild(modal));
		let LIGHTBOX__BTN = document.querySelectorAll('.js-lightboxbtn');
		LIGHTBOX__BTN.forEach((btn) => {
			btn.addEventListener('click', function (e) {
				e.preventDefault();
				let CURRENT_BOX = this.getAttribute('href').split('#')[1];
				document.getElementById(CURRENT_BOX).classList.add('open');
			});
		});
		let LIGHTBOX_CLOSE = document.querySelectorAll('.js-lightboxclose');
		LIGHTBOX_CLOSE.forEach((btn) => {
			btn.addEventListener('click', function (e) {
				e.preventDefault();
				let CURRENT_BOX = this.parentElement.parentElement.id;
				document.getElementById(CURRENT_BOX).classList.remove('open');

				let video = document.querySelector('.lightbox video');
				if (video) {
					video.pause();
				}
			});
		});
	}

	//mobile burger menu
	if (document.getElementById('mobileMenu') && document.getElementById('mobileBurger')) {
		let MOBILE_CONTAINER = document.getElementById('mobileMenu');
		let MOBILE_BURGER = document.getElementById('mobileBurger');
		let MOBILE_CLOSE = document.getElementById('mobileClose');

		MOBILE_BURGER.addEventListener('click', function () {
			MOBILE_CONTAINER.classList.add('open');
		});
		MOBILE_CLOSE.addEventListener('click', function () {
			MOBILE_CONTAINER.classList.remove('open');
		});
	}

	// Anchor links
	let ALL_LINKS = document.querySelectorAll('a');

	ALL_LINKS.forEach((link) => {
	
		if ((!link.classList.contains('js-lightboxbtn') && !link.classList.contains('ui-corner-all') && !link.classList.contains('learn-more-btn') && !link.classList.contains('js-lightboxclose') && !link.classList.contains('bookNow') && !link.classList.contains('bookingCMS'))  && link.id !== 'js-close-lightbox' && link.id !== 'menuClose' && !link.classList.contains('.js-div-expand')) {
			
			if(link.getAttribute('href').length > 1){
				link.addEventListener('click', function (e) {
					let LINK_HREF = this.getAttribute('href');
					if (LINK_HREF.indexOf('#') === 0) {
						if(LINK_HREF.indexOf('#_booking') !== 0){
							e.preventDefault();
							let CLEAN_LINK = LINK_HREF.split('#')[1];
						
							setTimeout(() => {
								animateTo(CLEAN_LINK);
							}, 500);
						}
					}
				});
			}

		}
	});



	// Check number of secondary links
	if (document.getElementById('secondary-nav')) {
		let allSecLinks = document.getElementById('secondary-nav').querySelectorAll('li');
		if (allSecLinks.length > 4) {
			allSecLinks.forEach((link) => {
				link.classList.add('long');
			});
		}
	}

	// SWIPER
	const swiperClass = '.sym-swiper';
	const swiperOps = {
		loop: true,
		speed: 1000,
		fadeEffect: { crossFade: true },
		allowTouchMove: true,
		breakpoints: {
			767: {
				allowTouchMove: false,
			},
		},
		on: {
			init: function (currentSwiper) {
				swiperADAduplicatedProcess(currentSwiper);
			},
		},
	};

	document.querySelectorAll(swiperClass).forEach((slider, i) => {
		const dataOps = slider.dataset.swiper ? JSON.parse(slider.dataset.swiper) : {};
		const combinedOps = Object.assign({}, swiperOps, dataOps);

		slider.setAttribute(`data-swiper${i}`, '');
		const swiper = new Swiper(`[data-swiper${i}]`, combinedOps);

		swiper.on('slideChange', (currentSwiper) => {
			swiperADAduplicatedProcess(currentSwiper);

			if(dataOps.customdots){			
				let arrayDots  = document.querySelectorAll(`${dataOps.customdots} .dot`);
				let lengthDots = arrayDots.length+1;

				arrayDots.forEach((dot, index)=>{
					dot.classList.remove('active');
					switch (currentSwiper.activeIndex) {
						//Last image position 
						case 0:
							arrayDots[arrayDots.length - 1].classList.add('active');
							break;
						//first image position
						case lengthDots:
							arrayDots[0].classList.add('active');
							break;
						case index + 1:
							dot.classList.add('active');
							break;
					}
				})
			}
		});
	});

	document.querySelectorAll('[data-swiper-goto]').forEach((item) => {
		const target = item.dataset.swiperGoto ? parseInt(item.dataset.swiperGoto) : 0;
		const slider = item.dataset.swiperTarget ? document.querySelector(item.dataset.swiperTarget) : item.closest('.sym-swiper');

		item.addEventListener('click', () => {
			slider.swiper.slideToLoop(target);
			item.parentNode.querySelectorAll('[data-swiper-goto]').forEach((itm) => itm.classList.remove('js-swiper_active'));
			item.classList.add('js-swiper_active');
		});
	});

	function swiperADAduplicatedProcess(currentSwiper) {
		currentSwiper.slides.forEach((slide) => {
			if (slide.classList.contains('swiper-slide-duplicate')) {
				slide.setAttribute('aria-hidden', true);
				slide.setAttribute('tabindex', '-1');

				// REMOVE IDs
				slide.querySelectorAll('[id]').forEach((elementWithID) => {
					elementWithID.setAttribute('id', '');
				});

				// SET TABINDEXs -1
				slide.querySelectorAll('a').forEach((elementWithID) => {
					elementWithID.setAttribute('tabindex', '-1');
				});
			}
		});

		currentSwiper.el.querySelectorAll('.swiper-slide .swiper-pagination-bullet').forEach((dotInSlide) => {
			dotInSlide.setAttribute('tabindex', '-1');
		});
	}

	// CMS forms BTN spans
	if (document.getElementsByClassName('form-module__submit').length > 0) {
		document.querySelectorAll('.form-module__submit').forEach((btn) => {
			btn.querySelectorAll('.btn').forEach((button) => {
				let innerHtml = button.innerHTML;
				button.innerHTML = innerHtml + '<span class="deco"></span>';
			});
		});
	}

	//accordion
	if(document.querySelectorAll('.js-accordion-title').length > 0){
		let ALL_TITLES = document.querySelectorAll('.js-accordion-title');
        ALL_TITLES.forEach(title => {
            title.addEventListener('click', function(){
                let fullHeight = this.nextElementSibling.getElementsByClassName('wrap')[0].offsetHeight + 40;
                if(!this.parentElement.classList.contains('open')){
                    this.nextElementSibling.style = 'height:'+fullHeight+'px';
                } else {
                    this.nextElementSibling.style = 'height:0px';
                }
                this.parentElement.classList.toggle('open');
            })
        });
	}

	//Charts
	if(document.querySelectorAll('table').length > 0){
		let arrayTables =document.querySelectorAll('table');
		arrayTables.forEach(table => {
			if (table.hasChildNodes() && table.children[0].tagName === 'TBODY') {
				let firstTr = table.children[0].querySelector('tr'); 
				if (firstTr) {
					let tdElements = firstTr.querySelectorAll('td');
					if(tdElements.length >= 1){ 
						 tdElements.forEach(td => {
							let th = document.createElement('th');
							 th.classList.add('jsthead');
							th.innerHTML = td.innerHTML;
							td.parentNode.replaceChild(th, td);
						});
					}
				}
			}
		});
	}

	//Cards - Verison 4
	if (document.getElementsByClassName('js-card-item').length > 0) {
		document.querySelectorAll('.js-card-item').forEach(item => {
			item.addEventListener('click', () => {
				const allCards = document.querySelectorAll('.js-card-item');
				allCards.forEach((element) => {
					element.classList.remove('active');
				});
				item.classList.add('active');
			});
		});
	}

	//Tapatio Script
	if (document.getElementsByClassName('golf-guest').length > 0) {
		document.querySelectorAll('.golf-guest').forEach((guest) => {
			let guestInput = guest.getElementsByTagName('input')[0];
			guestInput.setAttribute('min', 16);
			guestInput.addEventListener('change', function () {
				if (parseInt(this.value) < 16) {
					this.value = 16;
				}
			});
			guestInput.addEventListener('blur', function () {
				if (parseInt(this.value) < 16) {
					this.value = 16;
				}
			});
		});
	}

	//version3 calendar
	if (document.getElementsByClassName('js-date-prev').length > 0) {
		document.querySelectorAll('.js-date-prev').forEach((prev) => {
			let nextWeek = prev.nextElementSibling;
			let nextPrev = nextWeek.nextElementSibling;
			prev.addEventListener('click', function () {
				let currentDate = prev.getAttribute('data-min');
				if(prev.dataset.limit !== prev.dataset.min){
					let newDate = setRealDate(currentDate);
					let newMin = modifyDate(newDate, 7, false);
					let newMax = modifyDate(newDate, 1, false);

					nextPrev.dataset.max = newMax;
					prev.dataset.min = newMin;
					setSibling(prev,nextPrev,nextWeek);
					getEvents(newMin);

					
				}
				
			});
		});
		document.querySelectorAll('.js-date-next').forEach((next) => {
			let nextWeek = next.previousElementSibling;
			let prevNext = nextWeek.previousElementSibling;
			next.addEventListener('click', function () {
				let currentDate = next.getAttribute('data-max');
				let newDate = setRealDate(currentDate);
				let newMax = modifyDate(newDate, 7, true);
				let newMin = modifyDate(newDate, 1, true);

				prevNext.dataset.min = newMin;
				next.dataset.max = newMax;

				setSibling(prevNext,next,nextWeek);

				getEvents(newMin);
			});
		});
	}
	if(document.getElementsByClassName('js-month-prev').length > 0){
		document.querySelectorAll('.js-month-prev').forEach(prev => {
			let nextWeek = prev.nextElementSibling;
			let nextPrev = nextWeek.nextElementSibling;
			prev.addEventListener('click', function () {
				let targetMonth = prev.dataset.date;
				if(prev.dataset.limit !== nextWeek.dataset.month){ //avoids past months
					nextPrev.dataset.date = nextWeek.dataset.month;
					nextWeek.dataset.month = targetMonth;
					modifyMonth(prev,false,nextWeek);
					getEvents(targetMonth);
				}
			})
		})
		document.querySelectorAll('.js-month-next').forEach(next => {
			let nextWeek = next.previousElementSibling;
			let prevNext = nextWeek.previousElementSibling;
			next.addEventListener('click', function () {
				let targetMonth = next.dataset.date;
				prevNext.dataset.date = nextWeek.dataset.month;
				nextWeek.dataset.month = targetMonth;
				modifyMonth(next,true,nextWeek);
				getEvents(targetMonth);

			})
		})
	}

	//background - V4
	if (document.querySelectorAll('.background-quad.version-4 .background-quad__item .background-quad__copy').length > 0) {
		let arrayContent = document.querySelectorAll('.background-quad.version-4 .background-quad__item .background-quad__copy');
		let arrayImages  = document.querySelectorAll('.background-quad.version-4 .background-quad__imagen img');

		arrayContent.forEach(item => {
			item.addEventListener('mouseover',()=>{
			let atributeTarget = item.getAttribute('data-target').split('#')[1];
				activarImagen(atributeTarget)
			})
		});
		function activarImagen(atributeTarget){
			arrayImages.forEach( img => {
				img.classList.remove('js-activeImage')
				if(img.getAttribute('data-info')=== atributeTarget ){
					img.classList.add('js-activeImage');
				}
			});
		}
	}

	//Carousel - V6
	if(document.querySelectorAll('.carousel-block.version-6').length > 0 ){
		let thumbnails = document.querySelectorAll('.carousel-block.version-6 .thumbnails')[0];
		thumbnails.addEventListener('click', function () {
			document.querySelector('.carousel-block.version-6 .carousel-block__arrows .arrow-next').click();
		})
	}

})();

//Dots - carousel
function initializeDotsSlider(sliderSelector, dotsContainerSelector) {
	const slickSlider = $(sliderSelector);
	const dotsContainer = document.querySelector(dotsContainerSelector);

	if (dotsContainer) {
		const dotsArray = Array.from(dotsContainer.querySelectorAll(".dot"));
		const totalDots = dotsArray.length;

		function updateDots(activeIndex = 0) {
			dotsArray.forEach(dot => dot.classList.add("hidden"));

			if (totalDots <= 4) {
				dotsArray.forEach(dot => dot.classList.remove("hidden"));
				return;
			}

			// Siempre muestra el primer y último dot
			dotsArray[0].classList.remove("hidden");
			dotsArray[totalDots - 1].classList.remove("hidden");

			// Muestra los dots alrededor del índice activo
			const start = Math.max(1, activeIndex - 1);
			const end = Math.min(totalDots - 2, activeIndex + 1);
			for (let i = start; i <= end; i++) {
				dotsArray[i].classList.remove("hidden");
			}

			// Asegura que siempre haya al menos 4 dots visibles
			const visibleDots = dotsArray.filter(dot => !dot.classList.contains("hidden"));
			let neededDots = 4 - visibleDots.length;

			for (let i = 1; i < totalDots - 1 && neededDots > 0; i++) {
				if (dotsArray[i].classList.contains("hidden")) {
					dotsArray[i].classList.remove("hidden");
					neededDots--;
				}
			}
		}

		slickSlider.on("afterChange", function (event, slick, currentSlide) {
			updateDots(currentSlide);
		});
		updateDots(0);
	}
}


function modifyMonth(el,add,nextWeek){
	let currentTarget = el.dataset.date.split('-');
	let dateConvert = new Date(currentTarget[1],parseInt(currentTarget[0]) - 1, 1);
	nextWeek.innerHTML = dateConvert.toLocaleString('default', { month: 'long' }) + ', ' + dateConvert.getFullYear();
	if(add){
		dateConvert.setMonth(dateConvert.getMonth() + 1);
	} else {
		dateConvert.setMonth(dateConvert.getMonth() - 1);
	}

	let finalMonth = (dateConvert.getMonth() + 1)  < 10 ? '0' + (dateConvert.getMonth() + 1) : (dateConvert.getMonth() + 1) ;
	el.dataset.date = finalMonth + '-' +dateConvert.getFullYear();
	
}

function modifyDate(date, days, add) {
	let newDate;

	if (add) {
		newDate = new Date(date.getTime() + days * (24 * 60 * 60 * 1000));
	} else {
		newDate = new Date(date.getTime() - days * (24 * 60 * 60 * 1000));
	}

	let month = parseInt(newDate.getMonth()) + 1 < 10 ? '0' + (newDate.getMonth() + 1) : newDate.getMonth() + 1;
	let day = parseInt(newDate.getDate()) < 10 ? '0' + newDate.getDate() : newDate.getDate();

	return newDate.getFullYear() + '/' + month + '/' + day;
}
function setSibling(prev,next,week) {
	let weekHTML = '';
	let minDate = prev.dataset.min.split('/');
	let minDateConverted = new Date(minDate[0],parseInt(minDate[1]) - 1,minDate[2]);
	let maxDate = next.dataset.max.split('/');
	let maxDateConverted = new Date(maxDate[0],parseInt(maxDate[1]) - 1,maxDate[2]);

	if(minDate[1] === maxDate[1]){
		weekHTML = minDateConverted.toLocaleString('default', { month: 'long' }) + ' ' + minDate[2] + ' - ' + maxDate[2] + ', ' + minDate[0];
	} else {
		weekHTML = minDateConverted.toLocaleString('default', { month: 'long' }) + ' ' + minDate[2] + (minDate[0] === maxDate[0] ? '':', ' + minDate[0]) + ' - ' + maxDateConverted.toLocaleString('default', { month: 'long' }) + ' ' + maxDate[2] + ', ' + maxDate[0];
	}
	week.innerHTML = weekHTML;
}
function setRealDate(currentDate) {
	let newDate = new Date(currentDate);
	newDate.setHours(0, 0, 0, 0);
	return newDate;
}

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!HEADER.classList.contains('scroll')) {
				HEADER.classList.add('scroll');
				changeSrc(document.getElementById('headerLogo').getElementsByTagName('img')[0]);
				//submenu styling top for submenu
				if ((document.getElementsByClassName('menu-sub-full').length > 0 || document.getElementsByClassName('menu-sub-stacked').length > 0) && WINDOW_WIDTH > 600) {
					subMenuTop(8);
				}
			}
		}
	} else {
		if (HEADER.classList.contains('scroll')) {
			HEADER.classList.remove('scroll');
			changeSrc(document.getElementById('headerLogo').getElementsByTagName('img')[0]);
			if ((document.getElementsByClassName('menu-sub-full').length > 0 || document.getElementsByClassName('menu-sub-stacked').length > 0) && WINDOW_WIDTH > 600) {
				subMenuTop(18);
			}
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function changeSrc(elem) {
	let target = elem.getAttribute('data-scroll');
	let currentSrc = elem.getAttribute('src');

	elem.setAttribute('src', target);
	elem.setAttribute('data-scroll', currentSrc);
}

function convertBtn() {
	if (document.getElementsByClassName('btn').length > 0) {
		let ALL_BTNS = document.querySelectorAll('.btn');
		ALL_BTNS.forEach((btn) => {
			if (btn.getAttribute('type') !== 'submit') {
				if(btn.getElementsByClassName('deco').length === 0){
					let INNER_TEXT = btn.innerHTML;
					btn.innerHTML = '<span>' + INNER_TEXT + '</span><span class="deco"></span>';
				}
			}
		});
	}
	if (document.getElementsByClassName('signup-btn').length > 0) {
		document.querySelectorAll('.signup-btn').forEach((btn) => {
			let INNER_TEXT = btn.innerHTML;
			btn.innerHTML = INNER_TEXT + '<span class="deco"></span>';
		});
	}
}

//vanilla js scroll TO animation
function animateTo(target, distance = null) {

	g.classList.add('smooth');

	let totalDistance = distance != null ? distance : 350;
	
	

	setTimeout(() => {
		window.scrollTo(0, DOCUMENT_HEIGHT);
		
		var gotoTarget = WINDOW_WIDTH < 600 ? offset(document.getElementById(target)).top - 50 : offset(document.getElementById(target)).top - totalDistance;
		var from = window.pageYOffset || document.documentElement.scrollTop;

		var to = gotoTarget;
		var duration = 1300;
		var start = new Date().getTime();
		//time interval

		var timer = setInterval(function () {
			var time = new Date().getTime() - start;

			if (from <= to) {
				var y = easeInOutQuart(time, from, to - from, duration);
			} else {
				var y = easeInOutQuart(time, from, -(from - to), duration);
			}
			window.scrollTo(0, y);
			if (time >= duration) clearInterval(timer);
		}, 1000 / 60);

		window.scrollTo(0, from);
		g.classList.remove('smooth');

	}, 300);

	
	
}
//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b;
	return (-c / 2) * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}

function resizeWindow() {
	//calculate a new window size
	WINDOW_WIDTH = w.innerWidth || e.clientWidth || g.clientWidth;
	WINDOW_HEIGHT = w.innerHeight || e.clientHeight || g.clientHeight;

	//check header traditional with rate
	if (HEADER.classList.contains('header-traditional')) {
		if (WINDOW_WIDTH < 1000) {
			HEADER.style.height = 'auto';
			if (document.getElementsByClassName('rate-container').length > 0 && document.getElementById('navigation-container')!= null) {
				let NAV_HEIGHT = document.getElementById('navigation-container').clientHeight;
				let HEADER_HEIGHT = HEADER.clientHeight;

				HEADER.style.height = HEADER_HEIGHT + NAV_HEIGHT + 'px';
			}
		} else {
			HEADER.style.height = 'auto';
		}
	}
	if (WINDOW_WIDTH > 1090) {
		hoverArrow();

		if (document.getElementsByClassName('primary-long').length < 1) {
			checkNumberLinks();
		}
	}
	//submenu styling top for submenu
	if ((document.getElementsByClassName('menu-sub-full').length > 0 || document.getElementsByClassName('menu-sub-stacked').length > 0) && WINDOW_WIDTH > 600) {
		//subMenuTop(14);
	}
}
function subMenuTop(padding) {
	if (document.querySelectorAll('.submenu').length > 0) {
		let allSubmenus = document.querySelectorAll('.submenu');
		allSubmenus.forEach((submenu) => {
			console.log(HEADER.clientHeight);
			let fullHeader = HEADER.height;
			submenu.style.top = fullHeader + 'px';
		});
	}
}

function checkNumberLinks() {
	let linksCounter = 0;
		if(document.getElementById('primary-nav')){
		document
			.getElementById('primary-nav')
			.querySelectorAll('a')
			.forEach((link) => {
				if (!link.parentElement.parentElement.classList.contains('submenu')) {
					linksCounter++;
				}
			});
		if (linksCounter > 6) {
			document
				.getElementById('primary-nav')
				.querySelectorAll('a')
				.forEach((link) => {
					if (!link.parentElement.classList.contains('submenu')) {
						link.parentElement.classList.add('primary-long');
					}
				});
		}
	}
}

function hoverArrow() {
	//slider hover arrow
	if (document.getElementsByClassName('js-arrow-hover').length > 0) {
		let HOVER_ARROW = document.querySelectorAll('.js-arrow-hover');
		HOVER_ARROW.forEach((arrow) => {
			
				arrow.addEventListener('mouseleave', function (e) {
					let circle = arrow.getElementsByClassName('cursor')[0];
					circle.classList.remove('active')
				});
				arrow.addEventListener('mousemove', function (e) {
					let circle = arrow.getElementsByClassName('cursor')[0];
					let rect = arrow.getBoundingClientRect();
					circle.classList.add('active')

					circle.style.left = (e.clientX - rect.left) + 'px';
					circle.style.top = (e.clientY - rect.top) + 'px';
					
				});
			
		});
	}
}

function onLoad() {
	convertBtn();

	//Check anchor on URL
	let anchorHref = window.location.href;
	if (anchorHref.indexOf('#') > 0) {
		if (anchorHref.split('#').length === 2) {
			
			let windowTarget = anchorHref.split('#')[1];
			if (document.getElementById(windowTarget)) {
				//setTimeout(() => {
					
					animateTo(windowTarget);
				//}, 600);
			}
		}
	}
	if(document.querySelector('#typeToFilter')){
		animateTo('typeToFilter');
	}

	if(document.getElementsByClassName('hasDatepicker').length > 0 && WINDOW_WIDTH > 600){
		document.querySelectorAll('.hasDatepicker').forEach(picker => {
			if(picker.getAttribute('type') === 'date'){
				picker.parentElement.classList.add('moved')
			}
		})
	}

}


function addTrackingClass(){
	const allLinks = document.querySelectorAll('a');
	const allButtons = document.querySelectorAll('button');
	allLinks.forEach(link =>{
		if(link.href.includes('mailto:'))link.classList.add('track-email');
		if(link.href.includes('tel:'))link.classList.add('track-phone');
		if(link.href.includes('https://www.google.com/maps/'))link.classList.add('track-address');
		if(link.textContent.toLowerCase().includes('view floor plan'))link.classList.add('track-floorplan')
		validationText(link);
	})
	allButtons.forEach(link =>{
		validationText(link);
	})
}

function validationText(link){
	let arrayText = link.textContent.toLowerCase().split(' ');
	arrayText.forEach(text=>{
		if((text.includes('order') && text.includes('online')) || text.includes('order'))link.classList.add('track-order');
		if(text.includes('gift')||text.includes('card'))link.classList.add('track-gift');
		if(text.includes('spa')||text.includes('menu'))link.classList.add('track-menu');
		if(text.includes('book')&&!text.includes('facebook'))link.classList.add('book-now');
	})
}